import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import api from "../helpers/apiClient";
import { Alert, Button } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import Input from '../components/Input';
import LoginNavbar from '../components/LoginNavbar';

const giftrLink = window.location.hostname === 'seller.giftr.my' ? 'https://giftr.my' : 'https://giftr.sg'
const MIN_PASSWORD_LENGTH = 8

const validate = values => {
  const errors = {}
  if (!values.password) {
    errors.password = 'Required';
  } else if (values.password.length < MIN_PASSWORD_LENGTH) {
    errors.password = `Use at least ${MIN_PASSWORD_LENGTH} characters`;
  }
  if (values.confirmPassword !== values.password) {
    errors.confirmPassword = 'Passwords don\'t match';
  }
  return errors
}

class ResetPassword extends Component {

  constructor(props) {
    super(props)

    const params = new URLSearchParams(props.location.search)
    this.state = {
      email: params.get('email'),
      token: params.get('token'),
      done: false,
      error: null
    };
  }

  submit = (values) => {
    const { email, token } = this.state;
    this.setState({ error: null });
    return api('/auth/reset/confirm', {
      method: "post",
      body: JSON.stringify({ email, token, password: values.password })
    }).then(() => {
      this.setState({ done: true })
    }).catch(e => {
      this.setState({
        error: (e && e.message) || 'We could not reset your password. Please try again.'
      })
    })
  }

  renderBody() {
    const { handleSubmit, submitting } = this.props
    const { email, token, done, error } = this.state

    if (!email || !token) {
      return (
        <Alert variant="danger">
          <div>This reset link is incomplete. <Link to="/forgot_password">Request a new one</Link>.</div>
        </Alert>
      )
    }

    if (done) {
      return (
        <>
          <Alert variant="success">
            <div>Your password has been changed and all devices were logged out.</div>
          </Alert>
          <Link to="/login" className="d-grid text-decoration-none">
            <Button>LOG IN</Button>
          </Link>
        </>
      )
    }

    return (
      <>
        <p className="mb-0">Choose a new password for {email}.</p>
        {
          error &&
          <Alert variant="danger">
            <div>{error} <Link to="/forgot_password">Request a new link</Link></div>
          </Alert>
        }
        <Field className="form-control" name="password" label="New password" placeholder={`At least ${MIN_PASSWORD_LENGTH} characters`} type="password" autoComplete="new-password" component={Input} />
        <Field className="form-control" name="confirmPassword" label="Confirm new password" type="password" autoComplete="new-password" component={Input} />
        <Button
          type="submit"
          disabled={submitting}
          className="mt-4"
        >{submitting ? 'SAVING...' : 'SAVE NEW PASSWORD'}</Button>
      </>
    )
  }

  render() {
    const { handleSubmit } = this.props

    return (
      <div>
        <LoginNavbar host={giftrLink}></LoginNavbar>
        <div className="row" id="pwd-container">
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <form className="login-form d-grid gap-3 mx-3 shadow-sm" style={{textAlign: 'left', color:'#212529'}} onSubmit={handleSubmit(this.submit)}>
              <h4 className="mt-3 mb-4 text-center" style={{color:'#000'}}>Set a New Password</h4>
              {this.renderBody()}
            </form>
          </div>
          <div className="col-md-4"></div>
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: 'ResetPassword',
  validate,
  destroyOnUnmount: true
})(ResetPassword);
